import type { FunctionComponent, ReactNode } from "react";

import type { Props as BaseLinkProps } from "~/components/common/base-link";

import { StyledButton, StyledLinkButton, StyledOffsetContainer } from "./styles";

type BaseProps = {
  children: ReactNode;
  className?: string;
  target?: string;
};

type NormalButtonProps = BaseProps & {
  onClick?: () => void;
  variant: "button";
};

export type LinkButtonProps = BaseProps & {
  variant: "link";
} & BaseLinkProps;

type Props = NormalButtonProps | LinkButtonProps;

export const Button: FunctionComponent<Props> = props => {
  const { children, className, variant } = props;
  return (
    <StyledOffsetContainer backgroundColor="#fecc17">
      {variant === "button" ? (
        <StyledButton className={className} {...props}>
          {children}
        </StyledButton>
      ) : (
        <StyledLinkButton className={className} {...props}>
          {children}
        </StyledLinkButton>
      )}
    </StyledOffsetContainer>
  );
};

Button.displayName = "Button";
